import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyStreAppsComponent } from './_components/my-streapps/my-streapps.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgxFileDropModule } from 'ngx-file-drop';
import { WideCounterButtonComponent } from './_components/wide-counter-button/wide-counter-button.component';
import { ProfileLocationFieldComponent } from './_components/profile-location-field/profile-location-field.component';
import { BannerComponent } from './_components/banner/banner.component';
import { ProfileUserinfoFieldComponent } from './_components/profile-userinfo-field/profile-userinfo-field.component';
import { AboutMeFieldComponent } from './_components/about-me-field/about-me-field.component';
import { UpdateBannerDialogComponent } from './_components/update-banner-dialog/update-banner-dialog.component';
import { SebbieCounterComponent } from './_components/sebbie-counter/sebbie-counter.component';
import { SebbieInfoDialogComponent } from './_components/sebbie-info-dialog/sebbie-info-dialog.component';
import { UpdateLocationDialogComponent } from './_components/update-location-dialog/update-location-dialog.component';
import { DeleteAccountDialogComponent } from './_components/delete-account-dialog/delete-account-dialog.component';
import { CompletedTasksWidgetComponent } from './_components/completed-tasks-widget/completed-tasks-widget.component';
import { SupporterDialogComponent } from './_components/supporter-dialog/supporter-dialog.component';
import { SupporterWidgetComponent } from './_components/supporter-widget/supporter-widget.component';
import { ProfileComponent } from './profile/profile.component';
import { MySubscriptionsComponent } from './_components/my-subscriptions/my-subscriptions.component';
import { UpdateUserinfoDialogComponent } from './_components/update-userinfo-dialog/update-userinfo-dialog.component';

@NgModule({
  declarations: [
    ProfileComponent, 
    MyStreAppsComponent, 
    WideCounterButtonComponent, 
    ProfileLocationFieldComponent, 
    BannerComponent, 
    ProfileUserinfoFieldComponent,
    AboutMeFieldComponent,
    UpdateBannerDialogComponent,
    SebbieCounterComponent,
    SebbieInfoDialogComponent,
    UpdateLocationDialogComponent,
    DeleteAccountDialogComponent,
    CompletedTasksWidgetComponent,
    SupporterDialogComponent,
    SupporterWidgetComponent,
    MySubscriptionsComponent,
    UpdateUserinfoDialogComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    NgxFileDropModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProfileModule { }
